import React from "react";
import { IResourceComponentsProps } from "@refinedev/core";
import Cw8Edit from "components/cw8/Cw8Edit";

export const AutorPublicationsEdit: React.FC<IResourceComponentsProps> = () => {

    const resourceName :string = "autorPublication";
    return (
        <Cw8Edit
            resourceName = {resourceName}
        ></Cw8Edit>
    );
};
